import { render, staticRenderFns } from "./AddressEdit.vue?vue&type=template&id=0721f19f&scoped=true&"
import script from "./AddressEdit.vue?vue&type=script&lang=ts&"
export * from "./AddressEdit.vue?vue&type=script&lang=ts&"
import style0 from "./AddressEdit.vue?vue&type=style&index=0&id=0721f19f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0721f19f",
  null
  
)

export default component.exports